module.exports = __webpack_public_path__ + "img/logo-2022.6c3e7a71.png";